import { aggravates } from './aggravates';

// Bilingual option sets for CCS and Re-evaluation surveys.
// The English value (en) serves as the canonical id.

export const ccsOptionSets = {
  yesNo: [
    { en: 'Yes', es: 'Sí' },
    { en: 'No', es: 'No' },
  ],
  sinceLastVisit: [
    { en: 'Significantly Better', es: 'Significativamente Mejor' },
    { en: 'Better', es: 'Mejor' },
    { en: 'Same', es: 'Igual' },
    { en: 'Worse', es: 'Peor' },
    { en: 'Significantly Worse', es: 'Significativamente Peor' },
  ],
  yesNoUnknown: [
    { en: 'Yes', es: 'sí' },
    { en: 'No', es: 'No' },
    { en: 'Unknown', es: 'No Recuerdo' },
  ],
  spread: [
    { en: 'Expanded', es: 'Expandido' },
    { en: 'Shrunk', es: 'Encogido' },
    { en: 'About the same', es: 'Sobre el mismo' },
  ],
  bilateral: [
    { en: 'Relatively equal on each side', es: 'Relativamente igual en cada lado' },
    { en: 'Slightly worse on the right', es: 'Ligeramente peor a la derecha' },
    { en: 'Significantly worse on the right', es: 'Bastante peor a la derecha' },
    { en: 'Slightly worse on the left', es: 'Ligeramente peor a la izquierda' },
    { en: 'Significantly worse on the left', es: 'Bastante peor a la izquierda' },
  ],
  describe: [
    { en: 'Pain / Discomfort', es: 'Dolor / Molestia' },
    { en: 'Stiffness / Tightness', es: 'Rigidez / Tension' },
    { en: 'Altered sensation', es: 'Sensación alterada' },
    { en: 'Weakness', es: 'Debilidad' },
    { en: 'Noise / Grinding', es: 'Ruido / Chirrido' },
  ],
  bestDescribes: {
    painDiscomfort: [
      { en: 'Consistently dull and occasionally sharp', es: 'Dolor constante y a veces agudo' },
      { en: 'Sore', es: 'Doloroso' },
      { en: 'Dull / aching', es: 'Dolor Constante' },
      { en: 'Sharp / stabbing', es: 'Agudo' },
      { en: 'Shooting', es: 'Punzante' },
      { en: 'Pinching / pricking', es: 'Pellizcante / Puntiagudo' },
      { en: 'Burning', es: 'Ardor' },
      { en: 'Throbbing', es: 'Palpitante' },
      { en: 'Pins & needles', es: 'Alfileres y agujas' },
      { en: 'Pressing / squeezing', es: 'Presión / Apretón' },
      { en: 'Torsion', es: 'Retorcimiento' },
      { en: 'Cutting / lacerating', es: 'Cortante / Lacerante' },
    ],
    alteredSensation: [
      { en: 'Diminished sensitivity', es: 'Sensibilidad Disminuida' },
      { en: 'Numbness', es: 'Entumecimiento' },
      { en: 'Tingling', es: 'Hormigueo' },
      { en: 'Itchy', es: 'Picazón' },
      { en: 'Pins & needles', es: 'Alfileres y agujas' },
    ],
    weakness: [
      { en: 'Fatigue', es: 'Fatiga' },
      { en: 'Pain-induced weakness', es: 'Debilidad inducida por dolor' },
      { en: 'Strength loss independent of pain', es: 'Pérdida de fuerza independiente del dolor' },
    ],
  },
  symptomsBegin: [
    { en: 'Abruptly', es: 'Abruptamente' },
    { en: 'Gradual over time', es: 'Gradual en el tiempo' },
  ],
  caused: [
    { en: 'Repetitive activity', es: 'Actividad repetitiva' },
    { en: 'Single activity', es: 'Actividad única' },
    { en: 'Auto accident', es: 'Accidente automovilístico' },
    { en: 'Employment-related injury', es: 'Lesión relacionada con el empleo' },
    { en: 'No identifiable cause', es: 'Sin causa identificable' },
  ],
  onset: [
    { en: 'Worsening', es: 'Empeorando' },
    { en: 'Improving', es: 'Mejorando' },
    { en: 'Not changing significantly', es: 'No han cambiado significativamente' },
  ],
  reevalSymptoms: [
    { en: 'Dramatically improved', es: 'Dramáticamente mejorado' },
    { en: 'Improved', es: 'Mejorado' },
    { en: 'About the same', es: 'Sobre el mismo' },
    { en: 'Worse', es: 'Peor' },
  ],
  aggravates: aggravates,
  sleepPositions: [
    { en: 'Side', es: 'Lateral' },
    { en: 'Stomach', es: 'Estómago' },
    { en: 'Back', es: 'Atrás' },
  ],
  mattressTypes: [
    { en: 'Coil spring', es: 'Muelle helicoidal' },
    { en: 'Foam', es: 'Espuma' },
    { en: 'Air', es: 'Aire' },
    { en: 'Water', es: 'Agua' },
  ],
  otherVehicleSpeedEstimate: [
    { en: 'Stationary', es: 'Estacionado' },
    { en: 'Moving', es: 'En movimiento' },
    { en: 'Moving quickly', es: 'Moviéndose rápido' },
  ],
  pillowTypes: [
    { en: 'Foam', es: 'Espuma' },
    { en: 'Memory foam', es: 'Espuma de memoria' },
    { en: 'Fiberfill', es: 'Relleno de fibra' },
    { en: 'Feather', es: 'Pluma' },
    { en: 'None', es: 'Ninguno' },
  ],
  relief: [
    { en: 'Activity', es: 'Actividad o movimiento' },
    { en: 'Rest', es: 'Descansar' },
    { en: 'Sitting', es: 'Sentarme' },
    { en: 'Standing', es: 'Pararme' },
    { en: 'Hot', es: 'Aplicar calor' },
    { en: 'Cold', es: 'Aplicar frio' },
    { en: 'Stretches', es: 'Estirarme' },
    { en: 'Massage/rubbing', es: 'Masaje' },
    { en: 'Creams', es: 'Cremas' },
    { en: 'Over the counter pain meds', es: 'Medicamentos para el dolor sin prescripción' },
    { en: 'Prescription meds', es: 'Medicamentos con prescripción' },
  ],
  providers: [
    { en: 'Primary medical doctor', es: 'Médico de atención primaria' },
    { en: 'Chiropractor', es: 'Quiropráctico' },
    { en: 'Physical therapist', es: 'Fisioterapeuta' },
    { en: 'Massage therapist', es: 'Masajista' },
    { en: 'Medical specialist', es: 'Especialista Médico' },
    { en: 'Emergency department', es: 'Departamento de emergencia' },
  ],
  pregnant: [
    { en: 'No', es: 'No' },
    { en: 'Yes (confirmed due date)', es: 'Sí (fecha de parto confirmada)' },
    { en: 'Possibly (unconfirmed/suspected)', es: 'Posiblemente (no confirmado / sospechado)' },
    { en: 'Not applicable', es: 'No aplica' },
  ],
  yellowFlagsOptions: [
    {
      en: `It's terrible and I think it's never going to get any better.`,
      es: 'Es terrible y creo que nunca mejorará.',
    },
    { en: 'I feel down-hearted, blue, and sad.', es: 'Me siento abatido, y triste.' },
    {
      en: `In the past two weeks, I've experienced poor appetite or overeating.`,
      es: 'En las últimas dos semanas, he tenido poco apetito o he comido en exceso.',
    },
    { en: 'I am a hotheaded person.', es: 'Soy una persona exaltada.' },
    {
      en: 'Worrying thoughts go through my mind.',
      es: 'Pensamientos preocupantes pasan por mi mente.',
    },
    {
      en: 'Physical activity might harm my body.',
      es: 'La actividad física puede dañar mi cuerpo.',
    },
    {
      en: `I wouldn't have this much pain if there weren't something potentially dangerous going on in my body.`,
      es: 'No tendría tanto dolor si no hubiera algo potencialmente peligroso sucediendo en mi cuerpo.',
    },
    {
      en: `I can't seem to keep thoughts and feelings about my pain out of my mind.`,
      es: 'Parece que no puedo mantener los pensamientos y sentimientos sobre mi dolor fuera de mi mente.',
    },
    {
      en: 'I cannot do physical activities which might make my pain worse.',
      es: 'No puedo realizar actividades físicas que podrían empeorar mi dolor.',
    },
    { en: 'My work is too heavy for me.', es: 'Mi trabajo es demasiado pesado para mí.' },
    {
      en: 'I may not be able to perform my therapy because of how I feel emotionally.',
      es: 'Es posible que no pueda realizar mi terapia debido a cómo me siento emocionalmente.',
    },
  ],
  whereOccur: [
    { en: `At my employer's business`, es: 'En el negocio de mi empleador' },
    { en: 'On a remote worksite', es: 'En un lugar de trabajo remoto' },
    { en: 'While working from home', es: 'Mientras trabaja desde casa' },
    { en: 'During work-related travel', es: 'Durante viajes relacionados con el trabajo' },
  ],
  accidentDescriptions: [
    { en: `Rear-ended`, es: `Trasero` },
    { en: `Head-on`, es: `De frente` },
    { en: `Side impact`, es: `Impacto lateral` },
  ],
  secondaryCollisionsDescriptions: [
    { en: `None`, es: `Ninguno` },
    { en: `Pushed into vehicle in front`, es: `Empujado en el vehículo en frente` },
    { en: `Hit guardrail`, es: `Golpear la barandilla` },
  ],
  vehicleTypes: [
    { en: `Car`, es: `Coche` },
    { en: `Pickup truck`, es: `Camioneta` },
    { en: `SUV`, es: `SUV` },
  ],
  vehicleDamage: [
    { en: `Light`, es: `Poco daño` },
    { en: `Moderate`, es: `Daño moderado` },
    { en: `Heavy`, es: `Bastante daño` },
  ],
  vehicleDrivable: [
    { en: `Drivable`, es: `Manejable` },
    { en: `Not drivable`, es: `No manejable` },
  ],
  vehicleSitting: [
    { en: `Front driver`, es: `Conductor` },
    { en: `Front passenger`, es: `Co-piloto` },
    { en: `Rear driver`, es: `Atrás del conductor` },
    { en: `Rear passenger`, es: `Atrás del co-piloto` },
  ],
  roadConditions: [
    { en: `Dry`, es: `Seca` },
    { en: `Wet`, es: `Mojada` },
    { en: `Snow / Ice`, es: `Nieve/Hielo` },
  ],
  looking: [
    { en: `Toward left`, es: `Hacia la izquierda` },
    { en: `Straight ahead`, es: `Hacia al frente` },
    { en: `Toward right`, es: `Hacia la derecha` },
    { en: `Up`, es: `Hacia arriba` },
    { en: `Down`, es: `Hacia abajo` },
  ],
  bracedForImpact: [
    { en: `Braced for impact`, es: `Preparado para el impacto` },
    { en: `Unaware of the impending collision`, es: `Sin darse cuenta de la inminente colisión` },
  ],
  noticeSymptoms: [
    { en: `Immediately after the injury`, es: `Inmediatamente después de la lesión` },
    { en: `Later that same day`, es: `Más tarde ese mismo día` },
    { en: `The next day`, es: `El día siguiente` },
    { en: `In the days that followed`, es: `En los días que siguieron` },
  ],
  seekCare: [
    { en: `Immediately after the injury`, es: `Inmediatamente después de la lesión` },
    { en: `Later that same day`, es: `Más tarde ese mismo día` },
    { en: `The next day`, es: `El día siguiente` },
    { en: `In the days that followed`, es: `En los días que siguieron` },
  ],
};
